import { Component, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormControl,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { FormTranslationInputComponent } from '../form-translation-input.component';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'aw-translation-text-editor',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    AppendTestIdPipe,
    QuillEditorComponent,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './translation-text-editor.component.html',
})
export class TranslationTextEditorComponent
  extends FormTranslationInputComponent
  implements DoCheck
{
  protected readonly editorControl: FormControl<string> =
    this.formBuilder.nonNullable.control<string>('', []);

  constructor(public override ngControl: NgControl) {
    super(ngControl);

    this.subscription.add(
      this.editorControl.valueChanges.subscribe(value => {
        this.activeTextValue.setValue(value || '');
      })
    );
  }

  override ngDoCheck(): void {
    super.ngDoCheck();

    const activeValue: string = this.activeTextValue.value;
    if (this.editorControl.value !== activeValue) {
      this.editorControl.setValue(activeValue, { emitEvent: false });
    }

    if (this.activeTextValue.disabled && this.editorControl.enabled) {
      this.editorControl.disable({ emitEvent: false });
    } else if (this.activeTextValue.enabled && this.editorControl.disabled) {
      this.editorControl.enable({ emitEvent: false });
    }
  }
}
